import { render, staticRenderFns } from "../../../components/shared/physicianProfileAndPlans/BasePhysicianPlans.html?vue&type=template&id=6c1cd348&scoped=true&"
import script from "./PhysicianPlans.vue?vue&type=script&lang=js&"
export * from "./PhysicianPlans.vue?vue&type=script&lang=js&"
import style0 from "./PhysicianPlans.vue?vue&type=style&index=0&id=6c1cd348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1cd348",
  null
  
)

component.options.__file = "PhysicianPlans.vue"
export default component.exports